import LoginPopup from "./LoginPopup.js";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
const AgentLogin = () => {
    const navigate = useNavigate();
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [user, setUser] = useState(() => JSON.parse(sessionStorage.getItem("AGENT-ADMIN-INFO") || "{}"));

    const checkAuthentication = () => {
        const currentToken = sessionStorage.getItem("AGENT-TOKEN");
        const currentUser = JSON.parse(sessionStorage.getItem("AGENT-ADMIN-INFO") || "{}");
        setUser(currentUser);
        
        if (currentToken && currentUser?._id) {
          setIsAuthenticated(true);
        } else {
          setIsAuthenticated(false);
        }
      };
    
      // Handle successful login
      const handleLoginSuccess = () => {
        checkAuthentication();
        navigate('/voucher-list');
      };

    return (
        <LoginPopup open={true} onClose={() => {}} onLoginSuccess={handleLoginSuccess} />
    );
};

export default AgentLogin;